<template>
    <section @keydown="closeWithEsc">
        <router-view />
    </section>
</template>

<script>
    import { deal, digitalSignature } from '@/services/axios'

    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: 'ui-contract-sign-flow',

        props: {
            id: {
                type: [Number, String],
                required: true
            }
        },

        computed: {
            ...mapGetters('digitalSignatureStore', {
                product: 'getProduct',
                integration: 'getIntegration'
            })
        },

        created () {
            this.loadConfigs()
        },

        methods: {
            ...mapActions('digitalSignatureStore', [
                'setDeal',
                'setProduct',
                'setIntegration',
                'setFiles',
                'setEnvelope',
                'setLoading'
            ]),
            /**
             * Solicita o fechamento do modal de configuração
             */
            close() {
                const event = new CustomEvent('iframe--request-modal')
				window.parent.document.dispatchEvent(event)
            },
            /**
             * Carrega as configurações para o cadastro de um fluxo/envelope
             */
            loadConfigs: async function () {
                try {
                    this.setLoading(true)
                    // Busca as informações do negócio e produto
                    let response = await deal.getV2('', this.id)
                    await this.setProduct(response.data.data?.product)
                    await this.setDeal(response.data.data)

                    // Seta os documentos a serem enviados no fluxo/envelope
                    if (this.$route.query?.files) {
                        await this.setFiles(this.$route.query.files.split(','))
                    }

                    // Seta os dados de integração
                    await this.setIntegration({
                        id: this.$route.query?.integration_id,
                        slug: this.$route.query?.slug
                    })

                    // Busca as configurações de envelope do empreendimento
                    if (['docu_sign', 'click_sign'].includes(this.$route.query?.slug)) {
                        const params = {
                            product_id: this.product?.id,
                            integration_id: this.integration?.id
                        }
                        response = await digitalSignature.getAllV2('configuration-envelope', params)
                        this.setEnvelope(response.data)
                    }

                } catch (error) {
                    if (error?.data?.msg) this.$toastr.e(error.data.msg)
                    console.log(error)

                } finally {
                    this.setLoading(false)
                }
            },
            /**
             * Event handler que trata o evento para fechar o modal com a tecla esc
             */
            closeWithEsc(event) {
                if (event.keyCode === 27) {
                    this.close()
                }
            }
        }
    }
</script>
